import { Loader2 } from "lucide-react";

export function LoadingLine({ label }: { label: string }) {
  return (
    <div className="flex items-center gap-2 border border-border bg-card px-4 py-3 text-sm text-muted-foreground">
      <Loader2 size={16} className="animate-spin" />
      {label}
    </div>
  );
}
